import GridSection from "@/partials/sections/Section/GridSection";
import FooterTopLeftSection from "./components/FooterTopLeftSection";
import FooterTopRightSection from "./components/FooterTopRightSection";

export default function FooterTop({data}) {
  return (
    <div>
      <GridSection extraClass={"grid-cols-2 grid-cols-1 w-ful pb-12"}>
        <FooterTopLeftSection data={data}/>
        <FooterTopRightSection data={data}/>
      </GridSection>
    </div>
  );
}
